@if (isLoading) {
  <mds-loader [loadingText]="'Loading...'"></mds-loader>
}

@if (!isLoading) {
  <article class="epd-v2-dashboard" id="epdDashboard">
    <section class="dashboard-header">
      <section class="dashboard-header__headings">
        <div class="dashboard-header__headings-container">
          <span class="dashboard-header__headings-text">EPD Analysis of</span>
          <h1 class="dashboard-header__headings-name">{{ productName }}</h1>
        </div>
        @if (data.pdf_export_data?.standard_logo) {
          <div class="dashboard-header__headings-logo">
            <img [src]="data.pdf_export_data.standard_logo" alt="Standard Logo"/>
          </div>
        }
      </section>
      <section class="dashboard-header__controls">
        <div class="dashboard-header__controls-infochip">
          @if (selectedPcr) {
            <mds-chip
              [disabled]="true"
              [removable]="false"
              [showChipIcon]="false"
              label="{{ 'Declaration unit: ' + selectedPcr?.declared_unit }}"
            ></mds-chip>
          }
          <mds-chip
            [disabled]="true"
            [label]="'Last updated: ' + (data.updated | date: 'd MMM \'at\' HH:mm')"
            [removable]="false"
            [showChipIcon]="false"
          ></mds-chip>
        </div>
        <div class="dashboard-header__controls-selection">
          @if (selectedMethod) {
            <mds-dropdown-menu
              (selectedValueChange)="onChangeMethodology($event)"
              [helperText]="'Standard'"
              [options]="methodList"
              [selectedValue]="[selectedMethod]"
              [showArrows]="true"
              [text]="selectedMethod?.name"
            ></mds-dropdown-menu>
          }
          <mds-dropdown-menu
            (selectedValueChange)="onChangePcr($event)"
            [helperText]="'PCR'"
            [options]="pcrList"
            [selectedValue]="[selectedPcr]"
            [showArrows]="true"
            [text]="selectedPcr.name"
          ></mds-dropdown-menu>
          <mds-dropdown-menu
            *ngIf="languages?.length > 1"
            (selectedValueChange)="onChangeLanguage($event)"
            [helperText]="'Language'"
            [options]="languages"
            [selectedValue]="[selectedLanguage || {}]"
            [showArrows]="true"
            [text]="selectedLanguage?.text"
          ></mds-dropdown-menu>
        </div>
        @if (!!canPreview) {
          <div class="dashboard-header__controls-buttons">
            <mds-button
              (click)="previewAndExport()"
              [aria-label]="previewButtonLabel"
              [isIconLeft]="true"
              [icon]="MdsIcon.DOWNLOAD"
              type="primary"
              >
              {{ previewButtonLabel }}
            </mds-button>
          </div>
        }
      </section>
    </section>
    <h3 class="dashboard-chart-section-header">{{ isNewEPD ? 'Constituent Materials' : 'EPD Impact Assessment' }}</h3>
    @if (isNewEPD) {
      <ng-container *ngTemplateOutlet="newEPD"></ng-container>
    } @else {
      <section>
        <app-epd-impact-table [data]="layers"></app-epd-impact-table>
      </section>
      <section class="dashboard-chart-row-section">
        <app-epd-carbon-footprint class="chart-tile" [data]="selectedLayer"></app-epd-carbon-footprint>
        <app-epd-chg-ingredients
          class="chart-tile"
          [selectedLayer]="selectedLayer"
          [layers]="layers"
          [materialsBreakdown]="materialsBreakdown"
        ></app-epd-chg-ingredients>
      </section>
      <br class="page-break-after" />
      <section class="dashboard-lca-section">
        <mds-card [title]="'LCA Interpretation of' + data.name" [icon]="MdsIcon.MENU_BOOK">
          <section class="dashboard-header__controls">
            <div class="dashboard-header__controls-infochip">
              @if (selectedPcr) {
                <mds-chip
                  [disabled]="true"
                  [removable]="false"
                  [showChipIcon]="false"
                  [label]="'Declaration unit: ' + selectedPcr.declared_unit"
                ></mds-chip>
              }
              <mds-chip
                [disabled]="true"
                [label]="'Last updated: ' + (data.updated | date: 'd MMM \'at\' HH:mm')"
                [removable]="false"
                [showChipIcon]="false"
              ></mds-chip>
            </div>
          </section>
          <p [innerHTML]="showAllLCA ? data.epds[0].text_section : data.epds[0].text_section.slice(0, 500)"></p>
          @if (data.epds[0].text_section.length > 500) {
            <mds-button
              [size]="'small'"
              [type]="'tertiary'"
              (click)="showAllLCA = !showAllLCA"
              >
              {{ !showAllLCA ? 'Show all' : 'Show less' }}
            </mds-button>
          }
        </mds-card>
      </section>
    }
  </article>
}

<ng-template #newEPD>
  <section class="dashboard-chart-section">
    @for (chart of chartsData; track chart) {
      <div class="chart-container">
        <h3 class="chart-title">{{ chart.title }}</h3>
        <highcharts-chart [Highcharts]="Highcharts" [options]="chart.options" class=""></highcharts-chart>
      </div>
    }
  </section>

  <section class="dashboard-edit-section">
    <ngx-masonry
      (layoutComplete)="reloadMasonryLayout()"
      [options]="{ fitWidth: true, gutter: 40, horizontalOrder: false }"
      [ordered]="true"
      >
      @for (form of section; track form) {
        <app-epd-edit-section
          ngxMasonryItem
          class="masonry-item masonary-width"
          [data]="form"
          (modelChanged)="onEditSectionUpdated($event)"
        ></app-epd-edit-section>
      }
    </ngx-masonry>
  </section>

  <section class="dashboard-grid-section">
    @for (data of tableData; track data) {
      <app-epd-info-table [data]="data"></app-epd-info-table>
    }
  </section>

  <section class="dashboard-footer__controls">
    @if (!!canPreview) {
      <div class="dashboard-footer__controls-buttons">
        <mds-button
          (click)="previewAndExport()"
          [aria-label]="previewButtonLabel"
          [isIconLeft]="true"
          [icon]="MdsIcon.DOWNLOAD"
          type="primary"
          >
          {{ previewButtonLabel }}
        </mds-button>
      </div>
    }
  </section>
</ng-template>

